import {
  BellIcon,
  BriefcaseIcon,
  BuildingIcon,
  ClockIcon,
  CopyIcon,
  DashboardIcon,
  DigitalCertificateIcon,
  DocAddIcon,
  DollarSignIcon,
  FolderIcon,
  HelpIcon,
  InvoiceIcon,
  PadlockIcon,
  PeopleOutlineIcon,
  ReleasesIcon,
  SettingsIcon,
} from "@ficatranquilo/contabilidade.com-ui";
import { canOpenScreen } from "../../helpers/companyScreens";
import { buildSidebarMenu } from "./sidebarMenu";

/**
 * Menu da Visão Empresa, no Sidebar da lib. Mesmas regras de exibição de antes:
 * telas abertas por permissão usam o mesmo mapa dos guards do App.js
 * (canOpenScreen; ADM abre todas) e as telas só do ADM continuam só para ele.
 * Sete itens no ADM; os grupos abrem o painel secundário (decisão da R.6).
 */
export function useMenuCompany() {
  const auth = JSON.parse(localStorage.getItem("user_ow") || "{}");
  const isAdmin = auth.role === "ADM";
  const can = (screen) => canOpenScreen(screen, auth);

  return buildSidebarMenu([
    { key: "dashboard", label: "Dashboard", icon: <DashboardIcon />, route: "/" },
    {
      key: "projects-group",
      label: "Projetos",
      icon: <BriefcaseIcon />,
      items: [
        can("projects") && { key: "projects", label: "Projetos", icon: <BriefcaseIcon />, route: "/c/projects" },
        can("hoursApproval") && {
          key: "hours-approval",
          label: "Aprovação de horas",
          icon: <ClockIcon />,
          route: "/c/hours-approval",
        },
      ],
    },
    can("contracts") && { key: "contracts", label: "Contratos", icon: <ReleasesIcon />, route: "/c/contracts" },
    {
      key: "financial",
      label: "Financeiro",
      icon: <DollarSignIcon />,
      items: [
        can("paymentSchedules") && {
          key: "payments",
          label: "Pagamentos",
          icon: <InvoiceIcon />,
          route: "/c/payment-schedules",
        },
        can("taxInvoices") && { key: "nfes", label: "Notas fiscais", icon: <DocAddIcon />, route: "/c/nfes" },
      ],
    },
    {
      key: "people",
      label: "Pessoas",
      icon: <PeopleOutlineIcon />,
      items: [
        can("employees") && {
          key: "employees",
          label: "Colaboradores",
          icon: <PeopleOutlineIcon />,
          route: "/c/employees",
        },
        can("timeClock") && { key: "time-clock", label: "Ponto CLT", icon: <ClockIcon />, route: "/c/time-clock" },
        isAdmin && { key: "permissions", label: "Permissões", icon: <PadlockIcon />, route: "/c/permissions" },
        isAdmin && {
          key: "confidential-groups",
          label: "Grupos confidenciais",
          icon: <PadlockIcon />,
          route: "/c/confidential-groups",
        },
      ],
    },
    {
      key: "content",
      label: "Conteúdo",
      icon: <FolderIcon />,
      items: [
        isAdmin && { key: "alerts", label: "Comunicados", icon: <BellIcon />, route: "/c/alerts" },
        can("documents") && { key: "documents", label: "Documentos", icon: <FolderIcon />, route: "/c/documents" },
        isAdmin && { key: "quiz", label: "Questionários", icon: <HelpIcon />, route: "/c/quiz" },
        isAdmin && {
          key: "declarations",
          label: "Declarações",
          icon: <DigitalCertificateIcon />,
          route: "/c/declarations",
        },
      ],
    },
    {
      key: "settings",
      label: "Configurações",
      icon: <SettingsIcon />,
      items: [
        isAdmin && { key: "config", label: "Dados da empresa", icon: <BuildingIcon />, route: "/config" },
        isAdmin && {
          key: "contract-patterns",
          label: "Padrões de contrato",
          icon: <CopyIcon />,
          route: "/c/contract-patterns",
        },
        // Antes só pela aba "Integrações" de /config, que saiu no item 8.2
        isAdmin && { key: "api-keys", label: "Chaves de API", icon: <PadlockIcon />, route: "/c/api-keys" },
      ],
    },
  ]);
}
